// extracted by mini-css-extract-plugin
export default {"loadingWrapper":"styles__loadingWrapper___8H+kR"};